import appApi from '../../../../../../api/app-api';
import { toast } from 'react-toastify';

export const paySalaryForProfessorOperation = async (
  userId: number | null,
  workingHoursIds: { workingHourId: number; rateId: number }[],
  travelItems: { rateId: number; travelDate: Date; amount: number }[],
  setLoading: (loading: boolean) => any,
): Promise<boolean> => {
  try {
    if (!userId) {
      toast.warn('לא ניתן לאתק את מזהה העובד, נסה שוב בעוד מספר רגעים...');
      return false;
    }
    if (workingHoursIds.length === 0) {
      toast.warn('יש לבחור שעות פעילות');
      return false;
    }
    setLoading(true);
    await appApi.payProfessorSalary(userId, workingHoursIds, travelItems);

    setLoading(false);

    // Show success toast
    toast.success('התשלום התבצע בהצלחה!');
    return true;
  } catch (e) {
    setLoading(false);
    toast.error('שגיאה באישור התשלום, נסה שוב בעוד מספר רגעים...');
    return false;
  }
};
